import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchCurrentstatus } from './currentstatusAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchCurrentstatusDataWithFilters = createAsyncThunk(
  'Currentstatus/fetchCurrentstatusDataWithFilters',
  async ({ filter = {}, options = {} }) => {    
    const response = await fetchCurrentstatus({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const currentstatusSlice = createSlice({
  name: 'currentstatus',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentstatusDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCurrentstatusDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchCurrentstatusDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectCurrentstatusData = (state) => state.currentstatus.data;
export const selectCurrentstatusStatus = (state) => state.currentstatus.status;
export const selectCurrentstatusError = (state) => state.currentstatus.error;

export default currentstatusSlice.reducer;
